export default __webpack_public_path__ + "072db284bf0c8bb5efe513a4be933e54.svg";